import React from 'react';

const PageTitleSearch = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large">Resultaele cautarii pentru:</h1>
            </div>
        </div>
    );
};

export default PageTitleSearch;
